<a [href]="twitterUrl" target="_blank">
  <i class="fab fa-twitter"></i>
</a>
